import { render, staticRenderFns } from "./step-tech-body-type-mobile.vue?vue&type=template&id=61f47242"
import script from "./step-tech-body-type-mobile.vue?vue&type=script&lang=ts"
export * from "./step-tech-body-type-mobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports